
import {  Component,  OnInit,  Input,  Output,  EventEmitter,  ViewChild,} from "@angular/core";
//import { Component, OnInit } from "@angular/core";
import { FormBuilder,FormControl,FormGroup,Validators,} from "@angular/forms";
import { Router } from "@angular/router";
import { ItemModifierService } from "../ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "../shared/store/userInfo.store";


import { LoginService } from "../ApplicationServices/LoginService";

import { ConsignorService } from '../ApplicationServices/ConsignorService';
import { ConsigneeService } from '../ApplicationServices/ConsigneeService';


import { ProductDetailsService } from '../ApplicationServices/ProductDetailsService';

import { ConsignorElement } from '../models/ConsignorModel';
import { ConsigneeElement } from '../models/ConsigneeModel';

//  modal //////
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { convertActionBinding } from '@angular/compiler/src/compiler_util/expression_converter';

@Component({
  selector: "app-checkout",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.scss"],
})
export class CheckoutComponent implements OnInit {

  SKUCODE: string = null;
  COUPONCODE: string = null;

  @ViewChild("content") view;
  //  modal //////
  closeResult: string;
  moveForm: FormGroup;
  moveModalReference: any;


  alertmsg:string=null;
  showalert:boolean=false;

  loggedIn = false;
  cartItems = [];
  checkoutForm: FormGroup;
  paymentForm: FormGroup;

  shippingaddress:any;
  adresses=[];

  selectedDeliveryOption = "Normal Shipping";


  // adresses = [
  //   {
  //     id: 1,
  //     email: "abc@gmail.com",
  //     phone: "9804526251",
  //     postcode: "700055",
  //     state: "West Bengal",
  //     address: "42 NSC Bose Road , PO Naktala Kolkata",
  //     lastname: "Ray",
  //     firstname: "Abhik",
  //     isDefault: true,
  //   },
  //   {
  //     id: 2,
  //     email: "abasdasdc@gmail.com",
  //     phone: "9124526251",
  //     postcode: "700235",
  //     state: "Bihar",
  //     address: "73 Sarat Bose Road , PO Naktala Kolkata",
  //     lastname: "Mukherjee",
  //     firstname: "Parmit",
  //     isDefault: false,
  //   },
  // ];

  paymentvalue: any;
  options = [
    {
      id: "Cash On Delivery",
      value: "Cash On Delivery",
    },
    {
      id: "Credit Card",
      value: "Credit Card",
    },
    {
      id: "Debit Card",
      value: "Debit Card",
    },
  ];

  constructor(
    private loginService: LoginService,
    private infoStore: UserInfoStore,
    private router: Router,
    private itemModifierService: ItemModifierService, private cnorService: ConsignorService, private cneeService: ConsigneeService,
    private formBuilder: FormBuilder, private modalService: NgbModal,
    private proService: ProductDetailsService


  ) {
    this.checkoutForm = this.formBuilder.group({
      address: ["", Validators.required],
    });
  }
  getCartItems;

  ctotal: number = 0;
  total:  number = 0;  

  total1: number = 0;    total2: number = 0;
  couponamt : number=0;  couponpercent : number =0;

  ngOnInit() {


          //this.loggedIn = false;
         //sessionStorage.clear();
        //  this.infoStore.setInfo({});
       //  this.router.navigateByUrl("home");
      // this.totalCartItems = 0;
     //  this.cartItems = [];
    //  this.totalCartValue = 0;


    this.moveForm = new FormGroup({
      code: new FormControl(),
      //camount: new FormControl()

    });

    if (sessionStorage.getItem("OrderMaster_Id")) {

      this.loggedIn = true;
      this.total = 0;  this.total2 = 0;
      sessionStorage.setItem("CouponAmt", this.total1.toString());

      this.FillShippingAddressData();

      this.itemModifierService
        .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.cartItems = event;

                // if (event[0].OperationStatus == "Successfully Saved") {
               //   alert("done");
              // }

              this.cartItems.forEach((item) => {
              item.addresses = this.adresses;
              item.selectedAddress =
              this.adresses.length > 0 ? this.adresses[0] : "";
              
              this.total = this.total + (item.Price * item.Qty);
              this.total2 = this.total2 + (item.Price * item.Qty);
                

            });

           

          } 
          else 
          {
            this.cartItems = [];
            this.total = 0;
            this.total2 = 0;
            
          }
        });

      //  this.total2 = this.total ;


    } else {
      this.loggedIn = false;
      this.cartItems = [];
      this.total = 0;this.total2 = 0;
      sessionStorage.setItem("CouponAmt", this.total1.toString());
    }


    if( sessionStorage.getItem("ProceedPay_Id")=="1" ){

      this.infoStore.setCartInfo([]);
      sessionStorage.clear();
      this.infoStore.setInfo({});

     alert("Session Expired , Please Login  !!");
     this.router.navigateByUrl("login");

     }


  }


  FillShippingAddressData(){
    this.cneeService
      .getAllConsigneeMasterByUserIdData(parseInt(sessionStorage.getItem("UID")))
      .subscribe((event: any) => {
        if (event.length > 0) {
          this.adresses = event;

            // if (event[0].OperationStatus == "Successfully Saved") {
           //   alert("done");
          // }

        } else {
          this.adresses = [];
        }
      });


  }

  shippingChange(val) {
    this.selectedDeliveryOption = val;
  }
  loginredirect() {
    this.router.navigateByUrl("login");
  }

  homeRedirect() {
    this.router.navigateByUrl("home");
  }

  cartRedirect() {
    this.router.navigateByUrl("cart");
  }

  placeOrderRedirect() {

    // const formData = new FormData();
    //   var obj = {
    //     amount: this.total,
    //     currency: "INR",
    //     receipt: (sessionStorage.getItem("OrderMaster_Id")),
    //   };

    //   formData.append("params", JSON.stringify(obj));
    //   this.loginService.RazorcreateOrder(obj).subscribe((event: any) => {

    //       console.log(event);
    //       sessionStorage.setItem("RazorOrder_Id", event);
    //       sessionStorage.setItem("RazorAmount", (this.total.toString()));
    //       this.alertmsg = "Order Placed Successfully !";

    //       this.showalert = true;
    //       setTimeout(() => {
    //         this.showalert = false;
    //       }, 3000);


        //  this.open();
       // this.router.navigateByUrl("proceedpayment");
      //   });

      // if (sessionStorage.getItem("OrderMaster_Id")) {

      //   this.itemModifierService
      //     .getCartItemsOrderedAmt(parseInt(sessionStorage.getItem("OrderMaster_Id")))
      //     .subscribe((event: any) => {
      //       if (event.length > 0) {

      //         sessionStorage.setItem("RazorAmount",event[0].OperationStatus);

      //            // this.cartItems = event;
      //           // if (event[0].OperationStatus == "Successfully Saved") {
      //          //   alert("done");
      //         // }

      //       }
      //     });
      // }





  // this.cartItems = [];
  // this.total = 0;

  // this.itemModifierService
  // .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
  // .subscribe((event: any) => {
  //   if (event.length > 0) {
  //     this.cartItems = event;
     
  //     this.cartItems.forEach((item) => {
  //       item.addresses = this.adresses;
  //       item.selectedAddress =
  //       this.adresses.length > 0 ? this.adresses[0] : "";
  //       this.total = this.total + (item.Price * item.Qty);

      

  //     });
  //   } else {
  //     this.cartItems = [];
  //     this.total = 0;
  //   }
  // });


          var ii = this.total2;
          var jj = ii * 100 ;
     
            //sessionStorage.setItem("RazorAmount", "");
           //this.router.navigate(['proceedpayment'],  {queryParams: {invoiceamts: jj.toString() }}); 

          sessionStorage.setItem("CouponAmt", this.total1.toString());
          sessionStorage.setItem("RazorAmount", jj.toString());
          this.router.navigateByUrl("proceedpayment");

  }


  open() {
    const modalRef = this.modalService.open(this.view);
  }


  payment() {
    console.log(this.selectedDeliveryOption);
    console.log(this.paymentvalue);
    console.log(this.cartItems);
  }

  myFunction(id, adress) {
    this.cartItems.forEach((item) => {
      if (item.Id == id) {
        var sel = this.adresses.find((x) => x.address == adress);
        item.selectedAddress = sel;
      }
    });
  }

  private choose(value: string) {
    this.paymentvalue = value;
  }


  onMoveInfoSubmit( data ){

    this.SKUCODE="";
    this.COUPONCODE=data.code;

    //   SUCCESS#DYNAMIC#AMOUNT#100.00#02/07/2022
    this.proService.GetAllItemMasterBasic8_CouponDetailsByCouponCode(this.COUPONCODE,'').subscribe((datas) => {
    
    
    var C_nature ; var C_category ; var C_amt;
      
    var str = datas[0].OperationStatus;
    str = datas[0].OperationStatus.toString().split("#")[0];



    if(  str=='FAIL' ){

      this.alertmsg = "Failed , the entered coupon is not valid or is expired !!";
      this.showalert = true;

      str= datas[0].OperationStatus.toString().split("#")[1];
      C_amt=0;

     //this.total = this.total ;
    //this.FillCouponFrid();


    }else{

      this.alertmsg = "The entered coupon is validated successfully !!";
      this.showalert = true;

      //str= datas[0].MASSIVE.toString().split("#")[1];
     
      C_nature= datas[0].OperationStatus.toString().split("#")[1];
      C_category= datas[0].OperationStatus.toString().split("#")[2];
      C_amt= datas[0].OperationStatus.toString().split("#")[3];

      // this.ctotal= ( datas[0].OperationStatus.toString().split("#")[3] );

      ///  INSERT INTO COUPON_AMT TABLE TO VIEW FILL DATA ///////////

      // (document.getElementById(sper) as any).value = sperr.toFixed(2);
     // (document.getElementById(samtdeal) as any).value = samttdeal.toFixed(2);

     ///    var secondVal = this.offForm.value.StrikePrice;
     ///  

         // var final = amt * rate ;
        // this.offForm.patchValue({Price: final});
       //  var amt = this.offForm.value.CurrencyAmount; 

      if( C_category =='AMOUNT' ){
       

        var tot1;  var tot2;  var tot3;  var tot4;
        tot1  =  this.total.toString();
        tot2  =  ( tot1   -  C_amt  );
        //tot3  =  ( tot  +  C_amt  );
      
        this.total   =   Number( tot1.toString() ) ;         
        this.total1  =   Number( C_amt.toString() ) ; 
        this.total2  =   Number( tot2.toString() ) ; 
       

      }else{


        var tot1 ;  var tot2 ;  var tot3 ;  var tot4 ;
        tot1 = this.total.toString();
        tot2 = ( tot1 * (C_amt)/100 );
        tot3 = tot1 - tot2 ;
        //tot4 = tot1 + tot2 ;
       

        this.total   =  Number( tot1.toString() ) ;         
        this.total1  =  Number( tot2.toString() ) ; 
        this.total2  =  Number( tot3.toString() ) ;


          // this.couponamt = Number( ( this.total * C_amt.toFixed(2) ) / 100 );
         // this.total =  Number( this.total   -   this.couponamt );
        // this.total1=this.couponamt;      


      }



    }


    });

    setTimeout(() => {
      this.showalert = false;
    }, 8000);


    this.moveModalReference.close();


  }


  FillCouponFrid(){





  }



  openMoveModal1(content) {

    this.moveForm.reset();
    this.moveModalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.moveModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });


  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
     return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
     return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
   }
  }





}
